export default __webpack_public_path__ + "static/media/NW0010.34I-30939_-21661_0.1a1a7cde.jpg";